import { useState } from "react";
import { Link } from "react-router-dom";
import { LuTickets } from "react-icons/lu";
import { CiLogout } from "react-icons/ci";
import { CiLogin } from "react-icons/ci";
import { CiUser } from "react-icons/ci";

/* eslint-disable react/prop-types */
const DropdownMenu = ({ isAuthenticated, user, logout }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <div className="relative">
            <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="text-white hover:text-zinc-400 focus:outline-none"
            >
                {isAuthenticated ? user.name : "Usuario"}
            </button>
            {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-zinc-800 text-white rounded-md shadow-lg py-2 z-20">
                    {isAuthenticated ? (
                        <>
                            <Link
                                to="/tickets"
                                className="block px-4 py-2 hover:bg-zinc-700"
                                onClick={() => setIsDropdownOpen(false)}
                            >
                                <div className="flex gap-2 items-center">
                                    <LuTickets />
                                    Mis Tickets
                                </div>
                            </Link>
                            <Link
                                to="/profile"
                                className="block px-4 py-2 hover:bg-zinc-700"
                                onClick={() => setIsDropdownOpen(false)}
                            >
                                <div className="flex gap-2 items-center">
                                    <CiUser className="text-lg" />
                                    Mis Datos
                                </div>
                            </Link>
                            <Link
                                to="/login"
                                className="block px-4 py-2 hover:bg-zinc-700"
                                onClick={() => {
                                    logout();
                                    setIsDropdownOpen(false);
                                }}
                            >
                                <div className="flex gap-2 items-center">
                                    <CiLogout className="text-lg" />
                                    Cerrar Sesión
                                </div>
                            </Link>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                className="block px-4 py-2 hover:bg-zinc-700"
                                onClick={() => setIsDropdownOpen(false)}
                            >
                               <div className="flex gap-2 items-center">
                                    <CiLogin className="text-lg" />
                                    Iniciar session
                                </div>
                            </Link>
                            <Link
                                to="/register"
                                className="block px-4 py-2 hover:bg-zinc-700"
                                onClick={() => setIsDropdownOpen(false)}
                            >
                                <div className="flex gap-2 items-center">
                                    <CiUser className="text-lg" />
                                    Registrarse
                                </div>
                            </Link>
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;
